import { render, staticRenderFns } from "./monitoring-antrian.vue?vue&type=template&id=016944a8&scoped=true&"
import script from "./monitoring-antrian.vue?vue&type=script&lang=js&"
export * from "./monitoring-antrian.vue?vue&type=script&lang=js&"
import style0 from "./monitoring-antrian.vue?vue&type=style&index=0&id=016944a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016944a8",
  null
  
)

export default component.exports